import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useActiveBrandIdentifier } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier';

type Props = {
  onSuccess?: () => void;
};

export const useDeleteChatInstanceMutation = ({ onSuccess }: Props = {}) => {
  const dispatch = useContext(ChatStateDispatchContext);
  const brandIdentifier = useActiveBrandIdentifier();

  const apiClient = useChatApiClient();

  return useMutation({
    mutationKey: ['chat:delete'],

    mutationFn: (chatInstanceId: number) => {
      return apiClient.chatInstances.deleteChatInstance({
        chatInstanceId,
      });
    },

    onSuccess: (_, chatInstanceId) => {
      onSuccess?.();
      dispatch({
        type: 'chat-instance-removed',
        payload: {
          chatInstance: {
            id: chatInstanceId,
          },
          brandIdentifier,
        },
      });
    },
  });
};